<app-toolbar></app-toolbar>

<mat-drawer-container autosize>
	<mat-drawer
		[disableClose]="!breakpointSidenavState"
		[mode]="breakpointSidenavState ? 'side' : 'over'"
		[opened]="userSidenavState || breakpointSidenavState"
		[ngClass]="{
			'drawer-xsmall': drawerSize.xSmall,
			'drawer-small': drawerSize.small,
			'drawer-medium': drawerSize.medium,
			'drawer-large': drawerSize.large
		}"
	>
		@if (!breakpointSidenavState) {
			<section class="close-button-mobile">
				<button mat-icon-button (click)="close()">
					<lucide-angular name="x"></lucide-angular>
				</button>
				<span></span>
			</section>
		}

		<mat-accordion>
			@for (item of menuItems; track item; let i = $index) {
				@if (item.visible || validarVisualizadorProduccion) {
					<mat-expansion-panel
						class="accordion"
						hideToggle
						(opened)="item.active = true"
						(closed)="setActiveMenuItem(i, item.routeMenu)"
						[ngClass]="{ 'close-accordion': !item.active }"
					>
						<mat-expansion-panel-header>
							<div class="menu-layout">
								<mat-panel-title
									class="panel-description"
									[ngClass]="{ 'close-accordion': !item.active }"
								>
									<lucide-angular name="{{ item.iconName }}"></lucide-angular>
								</mat-panel-title>
								<mat-panel-description class="panel-description">
									{{ item.name }}
								</mat-panel-description>
								<span class="material-icons arrow open"
									>keyboard_arrow_right</span
								>
								<span class="material-icons arrow close"
									>keyboard_arrow_right</span
								>
							</div>
						</mat-expansion-panel-header>
						<mat-nav-list>
							@for (subMenu of item.subMenu; track subMenu) {
								@if (subMenu.visible) {
									<mat-list-item
										class="sidenav-item"
										routerLink="/{{ item.routeMenu }}/{{ subMenu.routeName }}"
									>
										<lucide-angular
											name="{{ subMenu.iconName }}"
											mat-list-icon
										></lucide-angular>
										{{ subMenu.name }}
									</mat-list-item>
								}
							}
						</mat-nav-list>
					</mat-expansion-panel>
				}
			}

			@if (!breakpointSidenavState) {
				<mat-divider class="custom-divider"></mat-divider>
				<section class="user-actions mat-typography">
					@if (!esOperadorSistema) {
						<button
							mat-flat-button
							#trigger="matMenuTrigger"
							[matMenuTriggerFor]="menu"
							class="user-action-btn"
							(menuOpened)="opened = trigger.menuOpen"
							(menuClosed)="opened = trigger.menuOpen"
						>
							<span>Cambiar empresa</span>
							@if (opened) {
								<lucide-angular
									name="chevron-down"
									size="18px"
								></lucide-angular>
							}
							@if (!opened) {
								<lucide-angular name="chevron-up" size="18px"></lucide-angular>
							}
						</button>
					}
					<mat-menu #menu="matMenu" #menuRef="matMenu">
						@for (empresa of userCompanies | keyvalue; track empresa) {
							<button mat-menu-item (click)="seleccionarEmpresa(empresa.value)">
								<span>{{ empresa.key }} </span>
							</button>
						}
					</mat-menu>
					<button (click)="logoff()" mat-flat-button class="user-action-btn">
						<span>Salir</span>
						<lucide-angular name="log-out" size="18px"></lucide-angular>
					</button>
				</section>
			}
		</mat-accordion>
	</mat-drawer>
	<mat-drawer-content>
		<main
			[ngClass]="{
				'm-2': breakpointSidenavState,
				'm-1': !breakpointSidenavState
			}"
		>
			<app-progress-spinner
				[displayProgressSpinner]="spinnerService.visibility | async"
			></app-progress-spinner>
			<router-outlet></router-outlet>
		</main>
	</mat-drawer-content>
</mat-drawer-container>
